import React, { useState } from "react";
import "./LoginForm.css";
import sensen_Login_Image from "../Assets/sensen_Login_Image.png";
import { APP_SERVICES_URL } from "../Constant/constant";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import axios from "axios";

const api = axios.create({
  baseURL: `${APP_SERVICES_URL}/sn-auth-service`, // Replace with your API base URL
});

const LoginForm = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [loading, setLoading] = useState(false);
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleCopyPaste = (event) => {
    event.preventDefault();
  };

  const customAuthentication = async (email, password) => {
    try {
      setLoading(false);
      const encodedCredentials = btoa(`${email}:${password}`);
      const response = await api.post("/operatorLogin", null, {
        headers: {
          Authorization: `Basic ${encodedCredentials}`,
        },
      });

      if (response.status === 200) {
        setLoading(true);
        const responseText = response.data;
        if (responseText && responseText.includes("resetpassword")) {
          // console.log("Navigating to:", responseText);
          // Redirect to the reset password page
          window.location.href = responseText;
        } else {
          // Proceed with the existing logic for successful login
          setIsError(false); // Reset the error state on successful login
          const data = response.data;
          const UpdatedData = JSON.parse(data);
          // Store the response data in the session storage
          localStorage.setItem("userData", JSON.stringify(UpdatedData));
          localStorage.setItem("isLogged", true);
          // Refresh the window to trigger re-rendering of App component
          window.location.href = "/scancam-edge/home";
          localStorage.setItem("showModal", true); // Set showModal state in session storage
        }
      } else {
        // Handle other error cases

        const responseData = response.data;
        if (responseData && responseData.error) {
          // Show a custom error message based on the server's response
          setIsError(true);
          setErrorText(responseData.error.message);
        } else {
          // Handle other error scenarios
          setIsError(true);
          setErrorText("An unknown error occurred.");
        }
      }
      // Check if response contains the text "resetpassword"
      const responseText = response.data;
      if (responseText && responseText.includes("resetpassword")) {
        // Redirect to the reset password page
        window.location.href = responseText;
      }
    } catch (error) {
      // Handle network error or other errors
      setLoading(false);
      setIsError(true);
      setErrorText("An error occurred while communicating with the server.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      return;
    }

    if (!password) {
      return;
    }

    if (email && password) {
      await customAuthentication(email, password);
    }
  };


  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <form method="post" onSubmit={handleSubmit} className="login-form">
          <div className="login-form-container">
            <div className="login-header">
              <img
                src={sensen_Login_Image}
                alt="logoSensen"
                height={52}
                width={168}
              />
              <h1 className="welcome-heading">Welcome</h1>
              <p className="welcome-text">
                Log in to SenSen.ai to continue to Scancam Portal.
              </p>
            </div>
            <div className="login-input-container">
              <div className="login-input-wrapper">
                <label htmlFor="email" className="input-label">
                  Username
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleEmailChange}
                  required
                  className="input-field"
                />
              </div>
              <div className="login-input-wrapper">
                <label htmlFor="password" className="input-label">
                  Password
                </label>
                <div className="forgot-password-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    required
                    value={password}
                    onChange={handlePasswordChange}
                    onPaste={handleCopyPaste}
                    onCopy={handleCopyPaste}
                    className="input-field"
                  />
                  <button
                    type="button"
                    onClick={handleTogglePassword}
                    className="password-toggle-button"
                  >
                    {showPassword ? <BsEyeSlash /> : <BsEye />}
                  </button>
                </div>
              </div>
              {isError && (
                <p className="error-message">
                  Wrong username or password
                </p>
              )}
            </div>
            <div className="login-actions">
              {/* <p className="forgot-password" onClick={handleForgotPassword}>
                Forgot Password?
              </p> */}
              <button
                type="submit"
                disabled={loading}
                className="submit-button"
              >
                {loading ? (
                  <svg
                    className="loading-spinner"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="spinner-circle"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="spinner-path"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                ) : (
                  "Continue"
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
